const headerDataTow = [{
		prop: "row_0",
		label: "指标",
		//columnwidth: 50,
	},
	{
		prop: "row_1",
		label: "一季度指标",
		//columnwidth: 95,
	},
	{
		prop: "row_2",
		label: "二季度指标",
		//columnwidth: 95,
	},
	{
		prop: "row_3",
		label: "三季度指标",
		//columnwidth: 150,
	},
	{
		prop: "row_4",
		label: "四季度指标",
		//columnwidth: 150,
	}
];
export default headerDataTow;